import React from "react";
import { isTouch } from "../helpers/Helpers";
import { LocStrings } from "../const/LocStrings";

function CenterMapMarker({ idx, centerData, lat, lng, activeCenterID, setActiveCenterID }) {
  const handleMouseEnter = () => {
    if (!isTouch()) {
      setActiveCenterID(centerData.id);
    }
  };
  const handleMouseLeave = () => {
    if (!isTouch()) {
      setActiveCenterID(0);
    }
  };

  const handleClick = (e, oldActiveID) => {
    console.log("Click!");

    // if (centerData.is_active!==true) {
    // 		e.preventDefault();
    // 		return;//doing nothing for coming soon centers.
    // }

    if (isTouch()) {
      console.log("IS touch:", oldActiveID, activeCenterID, centerData.id);
      if (oldActiveID !== centerData.id) {
        //for touch devices, first touch doesn't result in link jump
        e.preventDefault();
      }
      setActiveCenterID(centerData.id);
    }
  };

  const localizedCenterURL = () => {
    const lang = document.location.pathname.indexOf("/es") !== -1 ? "es" : "es";
    if (lang === "es") {
      return centerData.permalink.replace("/centers/", "/es/centers/");
    } else {
      return centerData.permalink;
    }
  };

  const wrappedCenter = (children) => {
    if (centerData.is_active === true) {
      return (
        <a
          href={localizedCenterURL()}
          className={
            "c-locator__marker " +
            (activeCenterID === centerData.id ? "is-active" : "") +
            (centerData.is_active !== true ? " is-inactive " : "")
          }
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => handleClick(e, activeCenterID)}
        >
          {children}
        </a>
      );
    } else {
      return (
        <div
          className={
            "c-locator__marker " +
            (activeCenterID === centerData.id ? "is-active" : "") +
            (centerData.is_active !== true ? " is-inactive " : "")
          }
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={(e) => handleClick(e, activeCenterID)}
        >
          {children}
        </div>
      );
    }
  };

  return wrappedCenter(
    <>
      <div className="c-locator__marker-pin"></div>
      <div className="c-locator__marker__num">{idx + 1}</div>

      <div className="c-locator__marker-info">
        {!centerData.is_active && <div className="center-note">{LocStrings.comingSoon}</div>}
        <div className="center-name">
          <span>{idx + 1}.</span> {centerData.name}
        </div>
        {centerData.location_details && <div class="location-details">{centerData.location_details}</div>}
        <div className="center-address">
          <div>{centerData.address.address_1}</div>
          {centerData.address.address_2.length > 0 && <div>{centerData.address.address_2}</div>}
          <div>
            {centerData.address.city}, {centerData.address.state} {centerData.address.zipcode}
          </div>
          {centerData.tel && centerData.tel.length > 0 && (
            <div>
              <strong>{LocStrings.tel}:</strong> {centerData.tel}
            </div>
          )}
          {centerData.hours && centerData.hours.length > 0 && (
            <div>
              <strong>{LocStrings.hours}:</strong> {centerData.hours}
            </div>
          )}
        </div>
        {activeCenterID === centerData.id && centerData.is_active === true && isTouch() && (
          <div className="center-tapagain link--arrow">{LocStrings.tapAgainForDetails}</div>
        )}
      </div>
    </>
  );
}

export default CenterMapMarker;
